import React from 'react'
import { Link } from 'react-router-dom'
import Projectimg1 from '../../assets/images/resources/peoject-one-hover-item-img.png'
import Projectimg2 from '../../assets/images/resources/peoject-one-hover-item-img-5.png'
import Projectimg3 from '../../assets/images/resources/peoject-one-hover-item-img-4.png'
import Projectimg4 from '../../assets/images/resources/peoject-one-hover-item-img-3.png'
import Projectimg5 from '../../assets/images/resources/peoject-one-hover-item-img-2.png'

function ProjectOne() {
  return (
    <div>
      <section className="peoject-one">
        <div className="peoject-one-shape-1" />
        <div className="container">
          <div className="peoject-one-title-box">
            <div className="section-three-title">
              <div
                className="section-three-title-text wow fadeInUp animated"
                data-wow-duration="1500ms"
                data-wow-delay="100ms"
              >
                <p>Latest Works</p>
              </div>
              <div
                className="section-three-title-title wow fadeInUp animated"
                data-wow-duration="1500ms"
                data-wow-delay="300ms"
              >
                <h2>Explore Our Global Works Latest Work Gallery</h2>
              </div>
            </div>
          </div>
          <div className="peoject-one-info-box">
            <div
              className="peoject-one-single peoject-one-hover-item wow fadeInUp animated"
              data-wow-duration="1500ms"
              data-wow-delay="100ms"
            >
              <div className="peoject-one-single-number">
                <span>Project 01</span>
              </div>
              <div className="peoject-one-single-title-box">
                <Link to="#">3D Illustration Design</Link>
              </div>
              <div className="peoject-one-single-btn">
                <Link to="/projects">
                  Project Details
                  <i className="icon-right-arrow" />
                </Link>
              </div>
              <div className="peoject-one-hover-item-box">
                <img
                  src={Projectimg1}
                  alt="team-item-hover"
                  className=" peoject-one-hover-item-box-img"
                />
              </div>
            </div>
            <div
              className="peoject-one-single peoject-one-hover-item wow fadeInUp animated"
              data-wow-duration="1500ms"
              data-wow-delay="200ms"
            >
              <div className="peoject-one-single-number">
                <span>Project 02</span>
              </div>
              <div className="peoject-one-single-title-box">
                <Link to="#">Brand Identity Design</Link>
              </div>
              <div className="peoject-one-single-btn">
                <Link to="/projects">
                  Project Details
                  <i className="icon-right-arrow" />
                </Link>
              </div>
              <div className="peoject-one-hover-item-box">
                <img
                  src={Projectimg2}
                  alt="team-item-hover"
                  className=" peoject-one-hover-item-box-img"
                />
              </div>
            </div>
            <div
              className="peoject-one-single peoject-one-hover-item wow fadeInUp animated"
              data-wow-duration="1500ms"
              data-wow-delay="300ms"
            >
              <div className="peoject-one-single-number">
                <span>Project 03</span>
              </div>
              <div className="peoject-one-single-title-box">
                <Link to="#">Media Marketing</Link>
              </div>
              <div className="peoject-one-single-btn">
                <Link to="/projects">
                  Project Details
                  <i className="icon-right-arrow" />
                </Link>
              </div>
              <div className="peoject-one-hover-item-box">
                <img
                  src={Projectimg3}
                  alt="team-item-hover"
                  className=" peoject-one-hover-item-box-img"
                />
              </div>
            </div>
            <div
              className="peoject-one-single peoject-one-hover-item wow fadeInUp animated"
              data-wow-duration="1500ms"
              data-wow-delay="400ms"
            >
              <div className="peoject-one-single-number">
                <span>Project 04</span>
              </div>
              <div className="peoject-one-single-title-box">
                <Link to="#">Web Optimization</Link>
              </div>
              <div className="peoject-one-single-btn">
                <Link to="/projects">
                  Project Details
                  <i className="icon-right-arrow" />
                </Link>
              </div>
              <div className="peoject-one-hover-item-box">
                <img
                  src={Projectimg4}
                  alt="team-item-hover"
                  className=" peoject-one-hover-item-box-img"
                />
              </div>
            </div>
            <div
              className="peoject-one-single peoject-one-hover-item wow fadeInUp animated"
              data-wow-duration="1500ms"
              data-wow-delay="500ms"
            >
              <div className="peoject-one-single-number">
                <span>Project 05</span>
              </div>
              <div className="peoject-one-single-title-box">
                <Link to="#">Mobile Apps Mockup Design</Link>
              </div>
              <div className="peoject-one-single-btn">
                <Link to="/projects">
                  Project Details
                  <i className="icon-right-arrow" />
                </Link>
              </div>
              <div className="peoject-one-hover-item-box">
                <img
                  src={Projectimg5}
                  alt="team-item-hover"
                  className=" peoject-one-hover-item-box-img"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>

  )
}

export default ProjectOne
